import React, { useState } from "react";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button } from "@mui/material";
import {
  ResponsiveContainer,
  BarChart,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Bar,
  Line,
} from "recharts";
import { useNavigate } from "react-router-dom";

const userData = [
  { name: "Mon", customers: 120, dealers: 40 },
  { name: "Tue", customers: 200, dealers: 60 },
  { name: "Wed", customers: 180, dealers: 55 },
  { name: "Thu", customers: 250, dealers: 70 },
  { name: "Fri", customers: 220, dealers: 65 },
  { name: "Sat", customers: 140, dealers: 45 },
  { name: "Sun", customers: 170, dealers: 50 },
];

const revenueData = [
  { name: "Mon", revenue: 1200 },
  { name: "Tue", revenue: 2400 },
  { name: "Wed", revenue: 1800 },
  { name: "Thu", revenue: 3200 },
  { name: "Fri", revenue: 2800 },
  { name: "Sat", revenue: 1500 },
  { name: "Sun", revenue: 2100 },
];

function ManageAnalytics() {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Revenue & Analytics</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Revenue & Analytics
        </p>
      </div>

      {/* CHARTS */}
      <div className="grid_sc gap_m">
        {/* TOTAL USERS */}
        <div className="cards table_card">
          <div className="cards_header mb_20">
            <div className="left_s">
              <h2>Total Users</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
              <Button className="btn btn_black icon_btn"><FileDownloadOutlinedIcon /> </Button>
            </div>
          </div>

          <ResponsiveContainer width="100%" height={320}>
            <BarChart data={userData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="customers" fill="#38B6FF" name="Customers" />
              <Bar dataKey="dealers" fill="#FF9F40" name="Dealers" />
            </BarChart>
          </ResponsiveContainer>
        </div>

        {/* TOTAL REVENUE */}
        <div className="cards table_card">
          <div className="cards_header mb_20">
            <div className="left_s">
              <h2>Total Revenue</h2>
            </div>
            <div className="right_s">
              <p>
                <span>A day</span>
                <span>A week</span>
                <span>A month</span>
                <span>A year</span>
              </p>
              <Button className="btn btn_black icon_btn"><FileDownloadOutlinedIcon /> </Button>
            </div>
          </div>

          <ResponsiveContainer width="100%" height={320}>
            <LineChart data={revenueData}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="name" />
              <YAxis />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="revenue"
                stroke="#38B6FF"
                strokeWidth={3}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
}

export default ManageAnalytics;
